import React from "react";
import Icon from "@ant-design/icons";

const GoogleSparkleSvg = () => (
  <svg
    width="1.7em"
    height="1.7em"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient
        id="blueSparkleGradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop offset="0%" stopColor="#004c8f" stopOpacity="1" />{" "}
        {/* Deep Blue */}
        <stop offset="50%" stopColor="#0073e6" stopOpacity="1" />{" "}
        {/* Mid Blue */}
        <stop offset="100%" stopColor="#00bfff" stopOpacity="1" />{" "}
        {/* Light Blue */}
      </linearGradient>
    </defs>

    <path
      d="M8 1l1.5 4.5L14 7l-4.5 1.5L8 13l-1.5-4.5L2 7l4.5-1.5L8 1z"
      fill="url(#blueSparkleGradient)"
    />

    <path
      d="M3 1l0.5 1.5L5 3l-1.5 0.5L3 5l-0.5-1.5L1 3l1.5-0.5L3 1z"
      fill="url(#blueSparkleGradient)"
    />
    <path
      d="M13 11l0.5 1.5L15 13l-1.5 0.5L13 15l-0.5-1.5L11 13l1.5-0.5L13 11z"
      fill="url(#blueSparkleGradient)"
    />
  </svg>
);

export const SparkleIcon = (props: any) => (
  <Icon component={GoogleSparkleSvg} {...props} />
);
